import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const PageLayer = props => {
  const [isValid, setIsValid] = useState(true);

  const handleOnError = e => {
    setIsValid(false);
  };

  return (
    <img
      src={props.src}
      alt=""
      className={props.className}
      onError={handleOnError}
      style={!isValid ? { display: 'none' } : undefined}
    />
  );
};

PageLayer.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
};

export default PageLayer;
